// eslint-disable-next-line
export default {
    lightBlue : "#dce8ff",
    blue : '#1b6cfc'
}